module.exports = __webpack_public_path__ + "img/processo de isolamento 2.aed59b3c.webp";